import { LoadingOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input, Row, Spin } from "antd";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import AuthServices from "../../services/AuthServices";

import "simple-react-validator/dist/locale/es";
import { SimpleReactValidatorHelper } from "../../helpers/SimpleReactValidatorHelper";
import { get_language, translate } from "../../locale";

const ForgotPassword = () => {
  const [values, setValues] = useState({
    username: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      locale: get_language,
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: SimpleReactValidatorHelper.elementMessage,
    })
  );

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("El Nombre de Usuario es incorrecto.");
      return;
    }
    try {
      const data = {
        username: values.username,
      };
      const res = await AuthServices.forgotPassword(data);
      if (
        res?.status !== undefined &&
        res.status >= 200 &&
        res.status < 300 &&
        res.data?.message === "email enviado"
      ) {
        setSuccess(true);
        setLoading(false);
      } else if (res.data?.error) {
        setError(res.data.message);
      } else {
        setError("No pudimos restablecer tu contraseña.");
      }
      setLoading(false);
    } catch (e) {
      console.error("onFinish error:", e.message);
      setError(e.message);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  return (
    <div className="flex flex-row w-screen justify-center items-stretch min-h-full max-w-7xl py-24">
      <div className="w-full md:w-1/2 flex justify-center">
        <Card
          title={translate("Recuperar contraseña")}
          className="w-full lg:w-7/12"
          bordered={false}
          headStyle={{ border: "none" }}
        >
          {error && (
            <Alert
              message={error}
              type="error"
              className="mb-6"
              closable
              onClose={() => setError("")}
            />
          )}
          {!success && (
            <Form
              initialValues={{ remember_me: true }}
              onFinish={onFinish}
              autoComplete="off"
              className="w-full"
            >
              <Form.Item>
                <Input
                  placeholder={translate("Nombre de usuario")}
                  className="border-custom_primary"
                  name="username"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {simpleValidator.current.message(
                  "username",
                  values.username,
                  "required",
                  get_language === "es"
                    ? {
                        messages: {
                          required: "El campo Nombre de usuario requerido",
                        },
                      }
                    : {}
                )}
              </Form.Item>
              <Row justify="end">
                <Button
                  disabled={disabled() || loading}
                  htmlType="submit"
                  type="primary"
                  className="bg-custom_primary"
                >
                  {loading && (
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ color: "#666666" }} />
                      }
                    />
                  )}
                  {translate("Enviar")}
                </Button>
              </Row>
              <Row className="mt-20">
                <Link to="/auth/login" className="mb-4">
                  {translate("Ya tengo cuenta")}
                </Link>
              </Row>
            </Form>
          )}
          {success && (
            <Row>
              {translate(
                "Te enviamos un email con un enlace para recuperar la contraseña."
              )}
              <Link to="/auth/login" className="mt-10">
                {translate("Ya recordé mi contraseña")}
              </Link>
            </Row>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
